import { render } from "./TitleMessage.vue?vue&type=template&id=5ae5e554&scoped=true"
import script from "./TitleMessage.vue?vue&type=script&lang=js"
export * from "./TitleMessage.vue?vue&type=script&lang=js"

import "./TitleMessage.vue?vue&type=style&index=0&id=5ae5e554&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae5e554"]])

export default __exports__